"use strict";
const createSearchStringQuery = searchString => ({
    or: [
        { qvantiId: parseInt(searchString.replace(/\D/g, ''), 10) || 0 },
        {
            '$organization.name$': {
                iLike: `%${searchString.replace(' ', '%')}%`,
            },
        },
        {
            '$customerSubUnit.customerNumber$': searchString,
        },
        {
            '$customerSubUnit.name$': {
                iLike: `%${searchString.replace(' ', '%')}%`,
            },
        },
        {
            '$supplierCustomer.customerNumber$': searchString,
        },
        {
            '$supplierCustomer.name$': {
                iLike: `%${searchString.replace(' ', '%')}%`,
            },
        },
    ],
});
module.exports = createSearchStringQuery;
